module.exports = __webpack_public_path__ + "img/4.7423c358.png";